<template>
  <b-row>
    <b-col cols="1" md="1" xl="1" lg="1">
      <div
        v-for="lang in languages"
        :key="lang"
        class="flag-management"
        style="padding-bottom: 8px"
        @click="loadTranslations(lang)"
      >
        <b-img
          v-tooltip="uniToolTipTranslation(lang, 'en-US')"
          style="width: 100px"
          class="flag"
          :src="'/static/img/flags/' + lang + '.png'"
          :alt="lang"
        />
        <!-- {{ uniTranslation(lang) }} -->
      </div>
    </b-col>
    <b-col cols="11" md="11" xl="11" lg="11">
      <b-card
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
        class="card-panel"
        style="margin-bottom:0px; border: solid black 1px; height: 85vh"
      >
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          <!-- Secondary Side -->
          <b-img
            style="width: 30px"
            class="flag"
            :src="'/static/img/flags/' + filterLang + '.png'"
          />{{ uniTranslation("TRNSL04") }}
        </div>
        <b-row>
          <b-col cols="12" md="6" xl="6" lg="6">
            <b-form-group
              :label="uniTranslation('TRNSL10')"
              label-for="filter-input"
              label-cols-sm="1"
              label-align-sm="left"
              label-size="xl"
              class="xl-0"
            >
              <b-input-group size="xl">
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  :placeholder="uniTranslation('TRNSL11')"
                ></b-form-input>

                <b-input-group-append>
                  <b-button variant="dark" :disabled="!filter" @click="filter = ''"
                    ><i class="fa-solid fa-broom"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="6" lg="6">
            <b-form-group
              :label="uniTranslation('TRNSL09')"
              :description="uniTranslation('TRNSL08')"
              label-cols-md="3"
              label-align-md="right"
              label-size="md"
              class="md-0"
            >
              <b-form-checkbox-group v-model="filterOn" class="mt-1">
                <b-form-checkbox value="translationCode">{{
                  uniTranslation("TRNSL06")
                }}</b-form-checkbox>
                <b-form-checkbox value="translation">{{
                  uniTranslation("TRNSL05")
                }}</b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row style="margin-top: 10px">
          <b-col cols="12" md="6" lg="3" xl="3">
            <b-button id="exportTranslationsExcel" block variant="success" @click="showExportModal"
              ><i :class="'fa-solid fa-file-arrow-down fa-2x'"></i
            ></b-button>
            <b-tooltip target="exportTranslationsExcel" triggers="hover" placement="bottom">
              {{ uniTranslation("TRNSL30") }}
            </b-tooltip>
          </b-col>
          <b-col cols="12" md="6" lg="3" xl="3">
            <b-button id="importTranslationsExcel" block variant="success" @click="setFile"
              ><i :class="'fa-solid fa-file-arrow-up fa-2x'"></i
            ></b-button>
            <b-tooltip target="importTranslationsExcel" triggers="hover" placement="bottom">
              {{ uniTranslation("TRNSL29") }}
            </b-tooltip>
            <b-form-file
              id="inputTranslationsExcel"
              v-model="file"
              style="visibility: hidden"
              placeholder="###Choose a file or drop it here..."
              drop-placeholder="###Drop file here..."
            ></b-form-file>
          </b-col>
        </b-row>
        <b-table
          sticky-header="100vh"
          hover
          fixed
          :items="items"
          :fields="fields"
          :filter="filter"
          :filter-included-fields="filterOn"
        >
          <template #cell(actions)="row">
            <b-button class="mr-1" variant="info" size="xl" @click="showEditModal(row.item)">
              <i class="fa-regular fa-pen-to-square"></i>
            </b-button>
            <!---->
            <b-button
              v-if="isDebug"
              size="xl"
              variant="danger"
              @click="deleteTranslation(row.item)"
            >
              <i class="fa-regular fa-trash-can"></i>
            </b-button>
          </template>
        </b-table>
        <b-row>
          <b-col> </b-col>
          <!---->
          <b-col v-if="isDebug" cols="2" md="2" lg="2" xl="2">
            <b-button block variant="primary" @click="showAddModal"
              ><i class="fa-solid fa-plus"></i
            ></b-button>
          </b-col>
        </b-row>
        <!-- MODALE EDIT DELLE TRADUZIONI -->
        <b-modal v-model="editModalShow" no-close-on-backdrop hide-footer hide-header>
          <b-card
            :style="{
              backgroundColor: coloreSfondo,
              color: coloreTesto,
              borderColor: coloreBordo
            }"
            class="card-panel"
            style="margin-bottom:0px;"
          >
            <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
              <!-- Secondary Side --><b>{{ uniTranslation("TRNSL05") }}: </b
              >{{ selectedItem.translationCode }}
            </div>
            <el-input v-model="selectedItem.translation" type="textarea"></el-input>
            <!--<b-form-input v-model="selectedItem.translation" type="text"></b-form-input>-->

            <b-row style="padding-top: 10px">
              <b-col></b-col>
              <b-col cols="2" md="2" lg="2" xl="2">
                <b-button block variant="danger" @click="hideEditModal"
                  ><i class="fa-regular fa-circle-xmark"></i></b-button
              ></b-col>
              <b-col cols="2" md="2" lg="2" xl="2">
                <b-button block variant="success" @click="updateTranslation"
                  ><i class="fa-regular fa-circle-check"></i></b-button
              ></b-col>
            </b-row>
          </b-card>
        </b-modal>
        <!-- FINE MODALE EDIT DELLE TRADUZIONI -->
        <!-- MODALE AGGIUNTA DELLE TRADUZIONI -->
        <b-modal v-model="addModalShow" no-close-on-backdrop hide-footer hide-header>
          <b-card
            :style="{
              backgroundColor: coloreSfondo,
              color: coloreTesto,
              borderColor: coloreBordo
            }"
            class="card-panel"
            style="margin-bottom:0px;"
          >
            <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
              <!-- Secondary Side --><b>{{ uniTranslation("TRNSL05") }} </b>
            </div>
            <el-input v-model="nuovaTraduzione" type="textarea"></el-input>

            <b-row style="padding-top: 10px">
              <b-col></b-col>
              <b-col cols="2" md="2" lg="2" xl="2">
                <b-button block variant="danger" @click="hideAddModal"
                  ><i class="fa-regular fa-circle-xmark"></i></b-button
              ></b-col>
              <b-col cols="2" md="2" lg="2" xl="2">
                <b-button block variant="success" @click="addTranslation"
                  ><i class="fa-regular fa-circle-check"></i></b-button
              ></b-col>
            </b-row>
          </b-card>
        </b-modal>
        <b-modal v-model="showExcelExport" no-close-on-backdrop hide-footer hide-header>
          <b-card
            :style="{
              backgroundColor: coloreSfondo,
              color: coloreTesto,
              borderColor: coloreBordo
            }"
            class="card-panel"
            style="margin-bottom:0px;"
          >
            <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
              <!-- Secondary Side --><b>{{ uniTranslation("TRNSL31") }} </b>
            </div>
            <b-row style="margin-bottom: 10px;">
              <b-col>
                {{ uniTranslation("TRNSL32") }}
              </b-col>
            </b-row>
            <b-form-input v-model="fileName" type="text" :state="nameState"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ uniTranslation("TRNSL33") }}
            </b-form-invalid-feedback>

            <b-row style="padding-top: 10px">
              <b-col></b-col>
              <b-col cols="2" md="2" lg="2" xl="2">
                <b-button block variant="danger" @click="hideExportModal"
                  ><i class="fa-regular fa-circle-xmark"></i></b-button
              ></b-col>
              <b-col cols="2" md="2" lg="2" xl="2">
                <b-button block variant="success" @click="exportFile"
                  ><i class="fa-regular fa-circle-check"></i></b-button
              ></b-col>
            </b-row>
          </b-card>
        </b-modal>
        <!-- FINE MODALE AGGIUNTA DELLE TRADUZIONI -->
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Notification, Input } from "element-ui";

export default {
  components: {
    "el-input": Input
  },
  props: {},
  data() {
    return {
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      coloreTitolo: "",
      coloreBarraTitolo: "",
      filterLang: "",
      filter: "",
      filterOn: [],
      selectedItem: {},
      editModalShow: false,
      addModalShow: false,
      nuovaTraduzione: "",
      items: [],
      itemsToExport: [],
      file: null,
      fileName: "",
      showExcelExport: false,
      hideExcelExport: false,
      uploadModel: {}
    };
  },
  computed: {
    ...mapGetters("_authModule", ["isAdmin", "isUnilab"]),
    ...mapGetters("_translationModule", ["currentLanguage", "languages"]),
    ...mapGetters("_colorsModule", ["cardColors"]),
    ...mapGetters("_commonModule", ["isDebug"]),

    fields: function() {
      return [
        {
          key: "translationCode",
          label: this.uniTranslation("TRNSL06"),
          sortable: true
        },
        {
          key: "translation",
          label: this.uniTranslation("TRNSL05"),
          sortable: true
        },
        { key: "actions", label: this.uniTranslation("TRNSL07") }
      ];
    },
    nameState() {
      return this.fileName.length > 0 ? true : false;
    }
  },
  watch: {
    file: function() {
      if (this.file != null) {
        this.upload();
      }
    },
    cardColors() {
      this.setColors();
    }
  },
  mounted: function() {
    var that = this;
    that.setColors();
    that.filterLang = that.currentLanguage;

    if (that.isAdmin == false && that.isUnilab == false) {
      that.$router.push("/");
    }

    that.getExportModelAction().then(data => {
      that.uploadModel = data;
    });

    that.loadTranslations(that.currentLanguage);
  },
  methods: {
    ...mapActions("_translationModule", [
      "getTranslationsAction",
      "update",
      "updateAddAll",
      "updateAddAllExport",
      "changeLanguageAction",
      "remove",
      "add",
      "getAllTranslationsAction",
      "getAllTranslationsExportAction",
      "getExportModelAction"
    ]),
    ...mapActions("_commonModule", ["setLoading"]),
    setColors() {
      var that = this;
      that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
      that.coloreBarraTitolo = that.cardColors[1];
      that.coloreTesto = that.cardColors[2];
      that.coloreTitolo = that.cardColors[3];
      that.coloreBordo = that.cardColors[6];
    },
    exportExcel() {
      var that = this;
      var ws = XLSX.utils.json_to_sheet(that.itemsToExport);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Languages");
      XLSX.writeFile(wb, that.fileName + ".xls");
    },
    callExport() {
      var that = this;
      that.getAllTranslationsExportAction().then(data => {
        that.itemsToExport = data;
      });
    },
    loadTranslations(lang) {
      var that = this;
      that.filterLang = lang;
      that.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });
      that.getTranslationsAction(lang).then(data => {
        that.items = data;
        that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
      });
    },
    showAddModal() {
      var that = this;
      that.nuovaTraduzione = "";
      that.addModalShow = true;
    },
    hideAddModal() {
      var that = this;
      that.addModalShow = false;
    },
    showExportModal() {
      var that = this;

      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0");
      var yyyy = today.getFullYear();
      today = yyyy + "_" + mm + "_" + dd;

      that.fileName = "TranslationsExport_" + today;
      that.callExport();
      that.showExcelExport = true;
    },
    hideExportModal() {
      var that = this;
      that.showExcelExport = false;
    },
    exportFile() {
      if (this.fileName.length > 0) {
        this.exportExcel();
        this.hideExportModal();
      }
    },
    showEditModal(item) {
      var that = this;
      that.selectedItem = JSON.parse(JSON.stringify(item));
      that.editModalShow = true;
    },
    hideEditModal() {
      var that = this;
      that.selectedItem = {};
      that.editModalShow = false;
    },
    updateTranslation() {
      var that = this;
      that.update(that.selectedItem).then(() => {
        that.reloadTranslations();
      });
    },
    addTranslation() {
      var that = this;
      that.add(that.nuovaTraduzione).then(() => {
        that.reloadTranslations();
      });
    },
    deleteTranslation(item) {
      var that = this;

      var msg = this.uniTranslation("TRNSL14");
      if (confirm(msg)) {
        that.remove(item).then(() => {
          that.reloadTranslations();
        });
      }
    },
    reloadTranslations() {
      var that = this;
      that.changeLanguageAction(that.currentLanguage).then(() => {
        that.loadTranslations(that.filterLang);
        that.selectedItem = {};
        that.editModalShow = false;
        that.addModalShow = false;
      });
    },
    upload() {
      var f = this.file;
      var that = this;
      var reader = new FileReader();
      reader.onload = function(e) {
        var data = new Uint8Array(e.target.result);
        // eslint-disable-next-line no-undef
        var workbook = XLSX.read(data, { type: "array" });
        let sheetName = workbook.SheetNames[0];
        /* DO SOMETHING WITH workbook HERE */
        let worksheet = workbook.Sheets[sheetName];
        // eslint-disable-next-line no-undef
        var list = XLSX.utils.sheet_to_json(worksheet);
        that.file = null;

        if (that.checkObjectBeforeUpload(list) == false) {
          Notification.error({
            title: that.uniTranslation("TRNSL219"),
            duration: 1500,
            offset: 36
          });
          return;
        }

        //console.log(list);
        that.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });
        that.updateAddAllExport(list).then(() => {
          that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
          that.reloadTranslations();
          Notification.success({
            title: that.uniTranslation("TRNSL34"),
            message: that.uniTranslation("TRNSL35"),
            duration: 2800,
            offset: 36
          });
        });
      };
      reader.readAsArrayBuffer(f);
    },
    setFile() {
      document.getElementById("inputTranslationsExcel").click();
    },
    checkObjectBeforeUpload(data) {
      var that = this;
      var mustHaveKeys = Object.keys(that.uploadModel);
      var toUploadKeys = Object.keys(data[0]);

      var res = true;

      mustHaveKeys.forEach(key => {
        var index = toUploadKeys.indexOf(key);
        if (index == -1) {
          res = false;
        }
      });

      return res;
    }
  }
};
</script>

<style lang="scss">
.card .card-header {
  color: transparent;
  background-color: transparent;
  padding: 0px;
}
.flag-management :hover {
  cursor: pointer;
}
</style>
